export default __webpack_public_path__ + "static/media/warning.a02a21a3.svg";